import React from 'react'
import Card1 from './Home/Web2/Card1'
import Card2 from './Home/Web2/Card2'

const Web2 = () => {
  return (
    <div>
        <div id='card1'><Card1/></div>
        <div id='card2'><Card2/></div>
    </div>
  )
}

export default Web2